import React, { useContext, Suspense } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { string, func } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { DataProvider } from '@thd-nucleus/data-sources';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ timeout }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path={routes.searchLoader.path}>
          <routes.searchLoader.component />
        </Route>
        <Route path={routes.storeSearch.path}> {
          channel === 'mobile'
            ? (<routes.storeSearchMobile.component />)
            : (<routes.storeSearch.component />)
        }
        </Route>
        <Route exact path={routes.storeDetails.path}>
          <routes.storeDetails.component />
        </Route>
        <Route exact path={routes.storeDirectory.path}>
          <routes.storeDirectory.component />
        </Route>
        <Route exact path={routes.stateDirectory.path}>
          <routes.stateDirectory.component />
        </Route>
        <Route exact path={routes.homeServices.path}>
          <routes.homeServices.component />
        </Route>
        <Route exact path={routes.rentalServices.path}>
          <routes.rentalServices.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  timeout: string,
};

App.defaultProps = {
  timeout: null,
};
